import { combineSlices } from '@reduxjs/toolkit';
import type { ILazyModuleSlices } from '@platform/core/types/modularity/ILazyModuleSlices';
import { baseApi } from './api/baseApi';
import { sessionSlice } from './slices/sessionSlice';
import { uiSlice } from './slices/uiSlice';
import { viewStateSlice } from './slices/viewStateSlice';

/** Кореневий reducer: кеш RTK Query + зрізи платформи; зрізи пакетів модулів (`module/<ключ>`) під'єднуються ліниво через injectInto. */
export const rootReducer = combineSlices(baseApi, sessionSlice, uiSlice, viewStateSlice).withLazyLoadedSlices<ILazyModuleSlices>();
